import { render, staticRenderFns } from "./addoredit.vue?vue&type=template&id=391660e2&"
import script from "./addoredit.vue?vue&type=script&lang=js&"
export * from "./addoredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports